import React, { Component } from 'react';
import Dashboard from './page/Dashboard';
import Homepage from './page/Homepage';
import Timeline from './page/Timeline';
import ReleaseNote from './page/ReleaseNote';
import Writeup from './page/Writeup';

import { Button } from './util';

import './App.css';


class App extends Component {
  constructor (props) {
    super(props);

    this.state = {
      page: <Homepage 
      runAppHandler={this.show('dashboard')}
      writeupHandler={this.show('writeup')}
      />
    };

    this.show = this.show.bind(this);
    this.initialize = this.initialize.bind(this);
  }
  
  initialize() {
    if (!localStorage.diary_posts) localStorage.diary_posts = '{}';
    localStorage.diary_visited = true;
  }

  show(name) {
    switch (name) {
      case 'dashboard': 
        return (() => {
          this.initialize();
          this.setState({page: <Dashboard 
            openDashboardHandler={this.show('dashboard')} 
            diaryRequest={this.show('timeline')}
          />})
        });
        break;
      
      case 'timeline': 
        return (date => {
          this.initialize();
          console.log(date);
          this.setState(
            {
              page: <Timeline 
                openDashboardHandler={this.show('dashboard')} 
                diaryRequest={this.show('timeline')}
                date={date}
              />
            });
        });
        break;

      case 'releasenote': 
        return (() => {
          this.initialize();
          this.setState({page: <ReleaseNote 
            openDashboardHandler={this.show('dashboard')} 
          />})
        });
        break;
      
      case 'writeup': 
        return (() => {
          this.initialize();
          this.setState({page: <Writeup 
            openDashboardHandler={this.show('dashboard')} 
          />})
        });
        break;
    }
  }

  componentDidMount() {
    document.title = "CGP Diary";
    if (localStorage.diary_visited) {
      this.setState({page: <Dashboard 
        openDashboardHandler={this.show('dashboard')}         
        diaryRequest={this.show('timeline')}
        />})
    }
    // this.show('dashboard')();
  }

  render() {
    let footer = '';

    if (localStorage.diary_visited) {
      footer = (<h4 >
          <button style={{fontSize: '18px', margin: 'auto .7em'}} type="button" onClick={this.show('releasenote')}>Release notes</button>
          <button style={{fontSize: '18px', margin: 'auto .7em'}} type="button" onClick={this.show('writeup')}>About this</button>
         <p><a href="https://cretgp.com">CreativeGP</a> (C) 2018</p>
      </h4>);
    }
    return (
      <div className="App">
        {this.state.page}

        {footer}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js